module.exports = __webpack_public_path__ + "static/media/logo-3.c08a9b68.png";